import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledLoadingButton = styled(
    ({
        variant = 'contained',
        startIcon,
        loadingPosition = !startIcon ? 'center' : 'start',
        loading,
        ...props
    }: LoadingButtonProps) => (
        <Tooltip title={props.title ?? ''}>
            <LoadingButton
                variant={variant}
                loadingPosition={loadingPosition}
                loading={loading}
                startIcon={startIcon}
                {...props}
            />
        </Tooltip>
    ),
)(({ theme, color }) => ({
    '&.MuiButton-root': {
        borderRadius: 8,
        fontWeight: 500,
        backgroundColor: color ?? theme.palette.primary.main,
        boxShadow: 'none',
    },
    '&.MuiButton-text': {
        color: color ?? theme.palette.error.main,
        backgroundColor: color ?? theme.palette.text.secondary,
        boxShadow: 'none',
    },
    '&.MuiButton-outlined': {
        color: color ?? theme.palette.primary.dark,
        backgroundColor: color ?? theme.palette.text.secondary,
        border: `2px solid ${
            color && color !== 'inherit' && theme.palette[color].main
        }`,
    },
    '&.MuiButton-outlined.Mui-disabled': {
        borderColor: theme.palette.text.disabled,
        color: theme.palette.text.disabled,
    },
    '&.MuiButton-text.Mui-disabled': {
        color: theme.palette.text.disabled,
    },
    '&.MuiButton-contained': {
        color: theme.palette.text.secondary,
    },
    '&.MuiButton-contained.Mui-disabled': {
        backgroundColor: theme.palette.text.disabled,
        color: theme.palette.text.secondary,
    },
    '&.MuiButton-contained.MuiButton-colorError': {
        color: theme.palette.grey[100],
        backgroundColor: theme.palette.error.main,
    },
    '&.MuiButton-outlined.MuiButton-colorSecondary': {
        color: theme.palette.grey[300],
        backgroundColor: theme.palette.text.secondary,
        border: `2px solid ${theme.palette.grey[300]}`,
    },
}));

export default StyledLoadingButton;
